import { render, staticRenderFns } from "./ActiveCashCreditRatioGrpByBranch.vue?vue&type=template&id=022541c2&"
import script from "./ActiveCashCreditRatioGrpByBranch.vue?vue&type=script&lang=js&"
export * from "./ActiveCashCreditRatioGrpByBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports